<template>
  <section class="container mx-auto">
    <div class="main max-w-7xl mx-auto p-6 grid grid-cols-12 relative">
      <div class="col-span-12 md:col-span-7 pt-3">
        <h1 class="title mb-4">
          Impulsa el <span class="text-blue">potencial<br /></span> de tu equipo
          con <br /><span class="text-blue">formación</span> de impacto
        </h1>
        <p class="main-text">
          En Selectalent, no solo seleccionamos talento, también lo
          potenciamos.<br />
          Diseñamos programas formativos personalizados, enfocados en los
          retos<br />
          específicos de tu empresa para convertir<br />
          a tus profesionales en verdaderos líderes.
        </p>
        <div class="flex flex-col md:flex-row justify-start gap-4 my-4">
          <button @click="navigateTo('/formaciones')">Ver formaciones</button>
          <button class="button2 font-bold" @click="navigateTo('/#contact')">
            Contactar <img :src="icon" alt="start" />
          </button>
        </div>
      </div>
      <div class="col-span-12 md:col-span-5 relative">
        <img :src="right" alt="" class="hidden md:block" />
        <img :src="mobile" alt="" class="block md:hidden" />
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
import icon from "@/assets/img/icon/click.svg";
import right from "@/assets/img/global/right.png";
import mobile from "@/assets/img/global/mobile-img.png";
</script>
<style scoped>
.main-text {
  color: black;
  font-weight: 900;
}
.title {
  color: var(--vt-c-black);
  font-family: "Poppins";
  font-size: 58px;
  font-style: normal;
  font-weight: 800;
}
button {
  border-radius: 40px;
  background: var(--vt-c-blue);
  display: flex;
  width: fit-content;
  height: 60px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 16px 24px;

  color: #f3f4f8;
  text-align: center;
  font-family: "Montserrat";
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0.2px;
  text-transform: capitalize;
  transition: all 0.3s ease;
  border: 2px solid var(--vt-c-blue);
}
.button2 {
  background-color: transparent;
  color: var(--vt-c-blue);
}
/* button:hover {
  background: transparent;
  border: 1px solid var(--vt-c-blue);
  box-shadow: 0 1px 9.1px 4px rgba(26, 122, 255, 0.3);
  color: var(--vt-c-blue);
}
.button2:hover {
  background: var(--vt-c-blue);
  border: 1px solid var(--vt-c-blue);
  color: white;
  box-shadow: 0 1px 9.1px 4px rgba(26, 122, 255, 0.3);
} */
@media (max-width: 1024px) {
  .title {
    font-size: 38px;
  }
}
@media (max-width: 768px) {
  .title {
    font-size: 28px;
  }
  button {
    font-size: 14px;
    width: 100%;
  }
  .main {
    flex-direction: column-reverse;
    display: flex;
  }
}

/* Small screens (tablets) */
@media (max-width: 640px) {
  .title {
    font-size: 24px;
  }
}
</style>
